<template>
  <div>
    <b-navbar toggleable="lg">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar toggleable>
        <b-navbar-brand>
          <div class="logo">
            <img src="../assets/logo1.png" />
          </div>
        </b-navbar-brand>
      </b-navbar>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
              <b-nav-item>
              <span class="nav-links" @click="allnotification"
                >All notifications</span
              >
            </b-nav-item>
            <b-nav-item>
              <span class="nav-links" @click="goBack">Admin section</span>
            </b-nav-item>
            <b-nav-item>
              <span class="nav-links" href="javascript:void(0)" @click="Logout"
                >Sign out</span
              >
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container>
      <div class="tabletext">
        <b-table-simple :hover="hover"  class="table-transition">
          <b-thead>
            <b-tr>
              <b-th>Modules</b-th>
              <b-th>Status</b-th>
              <b-th>Url</b-th>
              <b-th>LastModified</b-th>
            </b-tr>
          </b-thead>
          <b-tbody >
            <b-tr
              v-for="(options, index) in options"
              :key="index"
              class="th"
              :class="{ errorstatus: options.status === 'Error' }"
            >
              <b-td>{{ options.modules }}</b-td>
              <b-td>
                <template v-if="options.status === 'Error'">
                  <b-button v-b-modal.modal-center squared variant="link" class="errorstatus">{{
                    options.status
                  }}</b-button>

                  <b-modal
                    id="modal-center"
                    centered
                    title="Error Message"
                    hide-footer="true"
                  >
                    <p class="my-4 errorstatus">{{ options.errorMessage }}</p>
                  </b-modal>
                </template>
                <template v-else>
                  {{ options.status }}
                </template>
              </b-td>
              <b-td>{{ options.url }}</b-td>
              <b-td>{{ options.lastModified }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
       
      </div>
    </b-container>

    <img alt="footer" width="100%" src="../assets/footer.png" />
    <v-idle @idle="onidle" :loop="true" :wait="5" :duration="IDLETIMEOUT" />
  </div>
</template>
<script>
import LogoSvg from "../assets/logo.svg";
import { mapState, mapGetters, mapActions } from "vuex";
import router from "../router";
import { HTTP } from "../helpers/http-common";
import { APIURLS } from "../helpers/apiUrls";
import { IDLETIMEOUT } from "../helpers/constants";

export default {
  name: "HealthCheck",
  components: {
    LogoSvg,
  },
  data() {
    return {
      currentItems: [],
      hover: true,
      small: true,
      outlined: false,
      items: [],
      fields: [
        "modules",
        "status",
        "url",
        "lastModified",
        {
          key: "actions",
          label: "",
        },
      ],

      options: [],
      lr_display: "none",
      IDLETIMEOUT: IDLETIMEOUT,
    };
  },
  // created() {
  //   // Get initial data
  //   fetch("https://reqres.in/api/users")
  //     .then((response) => response.json())
  //     .then(
  //       (json) =>
  //         /* Map and use only some of the data for the example */
  //         (this.items = json.data.map((user) => {
  //           return {
  //             id: user.id,
  //             first_name: user.first_name,
  //             last_name: user.last_name,
  //           };
  //         }))
  //     );
  // },
  methods: {
    getHealthCheckData() {
      HTTP.get(`${APIURLS.getHealthCheckData}`)

        .then((response) => {
          this.items = response.data;
          this.options = response.data;
          return {
            modules: items.modules,
            status: items.status,
            url: items.url,
            lastModified: items.lastModified,
          };
        })
        .catch((error) => {
          // alert(error.response.data.Message);
        });
    },
    goBack() {
      router.push("/admin");
    },
     allnotification() {
      router.push("/allnotification");
    },
    Logout() {
      this.$store.dispatch("login/logout");
    },
    onidle() {
      this.$store.dispatch("login/logout");
    },

    // toggleDetails(item) {
    //   if (item._showDetails) {
    //     // if details are open, close them
    //     item._showDetails = false;
    //   } else if (item.details) {
    //     // if details already exists, show the details
    //     this.$set(item, "_showDetails", true);
    //   } else {
    //     HTTP.get(`${APIURLS.getHealthCheckData}`).then((response) => {
    //       this.item = response.data;
    //       return {
    //         status: item.status,
    //       };
    //       this.$set(item, "_showDetails", true);
    //     });
    //   }
    // },
    toggleDetails(row) {
      if (row.detailsShowing) {
        row.toggleDetails();
      } else {
        this.currentItems.forEach((items) => {
          this.$set(items, "_showDetails", false);
        });
        this.$nextTick(() => {
          row.toggleDetails();
        });
      }
    },
  },

  mounted() {
    this.getHealthCheckData();
    this.$store.dispatch("login/refreshToken");
  },
};
</script>
<style scoped lang="scss">
.goback {
  font-size: 25px;
  cursor: pointer;
}
.goback:hover {
  text-decoration: underline;
}
.login-container {
  background: #fff;
  border: 1px solid #fff;
  border-radius: 14px;
  background-color: white;
  // box-shadow: 0px 3px 5px 3px #aaaaaa;
  // padding: 51px;
}
.logo {
  img {
    width: 40%;
  }
}
.th {
  text-align: left !important;
  // border: inset !important ;
}
table {
  width: 100%;
  // border: 1px solid #ccc;
}

td {
    color: #373a3c !important;
}
table.table-transition .flip-list-move {
    transition: transform 1s;
}
.errorstatus {
  color: #d23037;
}
.opened {
  background-color: yellow;
}

.table th, .table td {
    padding: 0.75rem;
    vertical-align: middle!important;
    border-top: 1px solid #dee2e6;
    font-size: 15px;
    text-align: initial;
}
.table thead th {
    border-bottom: 3px solid #6e6e6e!important;
}
.btn-link {
    font-weight: 600;
    color: #D23037;
    text-decoration: none;
}
.v-idle {
  display: none;
}
</style>